import { SearchUser } from 'lib-search-types';

export type PhoneUserDuplicate = SearchUser & { duplicate?: boolean };

/**
 * Flattens additional_phone_numbers array into multiple users with phone_number
 * { phone_number: '012', additional_phone_numbers: ['123', '456'] } -> [{
 * phone_number: '012' }, { phone_number: '123' }, {phone_number: '456' }]
 *
 * @param users
 * @returns Users
 */
export const spreadPhoneUsers = (users: SearchUser[]): PhoneUserDuplicate[] => {
  if (!users?.length) {
    return [];
  }

  return users.flatMap((user) => {
    const mappedUsers: PhoneUserDuplicate[] = [user];

    if (user.additional_phone_numbers?.length) {
      for (const phoneNumber of user.additional_phone_numbers) {
        mappedUsers.push({
          ...user,
          phone_number: phoneNumber,
          duplicate: true,
        });
      }
    }

    return mappedUsers;
  });
};
